module.exports = __webpack_public_path__ + "img/LogoDashboard-27.c9183c46.svg";